"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partition = void 0;
const augmentative_iterable_1 = require("augmentative-iterable");
const partition_recipe_1 = require("../recipes/partition-recipe");
exports.partition = (0, partition_recipe_1.partitionRecipe)(Symbol.iterator, augmentative_iterable_1.resolver);
